import { SectionShell } from "@/components/design-system/SectionShell";
import { ResultCard } from "@/components/ui/result-card";

const code = `import { ResultCard } from "@/components/ui/result-card"

<ResultCard
  client="Schorr Law"
  context="US law firm, worked agency-side"
  tag="Conversion rate"
  figure="7.5% to 35%"
  figureLabel="conversion rate, at ~$41 per case"
  detail="Rebuilt the account around intent. Conversion rate nearly 5x'd..."
/>`;

export function ResultCardSection() {
  return (
    <SectionShell
      id="result-card"
      title="Result card"
      description={
        <>
          A single client outcome: an icon + client header with an optional metric
          tag, a headline figure, a supporting label, and the detail in a faint
          inner panel. Token-based, so it works on the light-locked marketing page
          and in light or dark here. Used by the landing page's Results section.
        </>
      }
      whenToUse={
        <ul>
          <li>Case-study outcomes with a headline number and context.</li>
          <li>A grid of client results as proof.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            A bare dashboard KPI with no narrative — use the <code>Stat</code> tile.
          </li>
          <li>A client quote — use the <code>Testimonial</code> carousel.</li>
        </ul>
      }
      preview={
        <div className="grid gap-4 sm:grid-cols-2">
          <ResultCard
            client="Schorr Law"
            context="US law firm, worked agency-side"
            tag="Conversion rate"
            figure="7.5% to 35%"
            figureLabel="conversion rate, at ~$41 per case"
            detail="Rebuilt the account around intent. Conversion rate nearly 5x'd and cost per qualified case landed around $41."
          />
          <ResultCard
            client="Elec Direct"
            context="US retailer, worked agency-side"
            tag="Revenue"
            figure="+$230k"
            figureLabel="in added revenue"
            detail="Found the wasted spend, moved it to what was working, and added $230k in revenue without a bigger budget."
          />
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            Props: <code>client</code>, <code>figure</code>,{" "}
            <code>figureLabel</code>, and optional <code>context</code>,{" "}
            <code>tag</code>, <code>detail</code>.
          </li>
          <li>
            The <code>tag</code> is a truthful metric category (e.g. "Revenue"),
            not an up/down delta. Omit it for a plainer card.
          </li>
          <li>
            The figure uses the display font at a fixed size (not the oversized
            marketing metric), so it sits comfortably inside a card grid.
          </li>
          <li>
            On the landing page these are presented in the auto-scrolling{" "}
            <code>Carousel</code>; give each card a fixed width plus{" "}
            <code>shrink-0 snap-start</code> when used there.
          </li>
        </ul>
      }
    />
  );
}
